import * as ActionTypes from 'store/actionTypes';

export const changeOrganizationOptions = ({owner}:any) => ({
  type: ActionTypes.STORE_FILTERED_ORGANIZATION_OPTIONS,
  payload: owner
});



